import { render, staticRenderFns } from "./NewHistory.vue?vue&type=template&id=5fb48aad&scoped=true"
import script from "./NewHistory.vue?vue&type=script&lang=js"
export * from "./NewHistory.vue?vue&type=script&lang=js"
import style0 from "./NewHistory.vue?vue&type=style&index=0&id=5fb48aad&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb48aad",
  null
  
)

export default component.exports